import {FC, useCallback} from "react";
import styled from "@emotion/styled/macro";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {setIsOpenPlayerPool} from "modules/actions";
import {PureButton} from "components/Common";
import {breakpoints} from "assets/theme";
import emptyPlayer from "assets/images/fanVote/emptyPlayer.svg";
import {ReactComponent as AddIcon} from "assets/images/icons/add.svg";

const Title = styled.div`
	color: ${({theme}) => theme.colorPalette.white};
	text-align: center;
	font-size: calc(24px + 1vw);
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;

	@media (min-width: 1440px) {
		font-size: 60px;
	}
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	padding: 20px 66px 12px;

	@media (min-width: ${breakpoints.tablet}) {
		min-height: 737px;
		padding-bottom: 133px;
	}
`;

const ImgWrapper = styled(PureButton)`
	display: flex;
	flex-direction: column;
	width: 100%;
	position: relative;
	margin-bottom: 24px;
	max-width: 420px;

	img {
		width: 100%;
	}

	@media (min-width: ${breakpoints.mobile}) {
		width: 45%;
	}

	@media (min-width: ${breakpoints.tablet}) {
		width: 70%;
	}

	&:hover svg circle {
		fill: #a408a4;
	}
`;

const AddIconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0);
	bottom: 30px;
	width: 22.5%;

	svg {
		width: 100%;
		height: auto;

		circle {
			transition: all 0.3s ease-in-out;
		}
	}
`;

export const EmptyFanVotePlayer: FC = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();

	const clickHandler = useCallback(() => {
		dispatch(setIsOpenPlayerPool(true));
	}, [dispatch]);

	return (
		<Wrapper>
			<ImgWrapper onClick={clickHandler}>
				<img src={emptyPlayer} alt="empty player" />

				<AddIconWrapper>
					<AddIcon />
				</AddIconWrapper>
			</ImgWrapper>

			<Title>
				{t("page.vote.empty_player.title_1")}
				<br />
				{t("page.vote.empty_player.title_2")}
			</Title>
		</Wrapper>
	);
};
